import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../utilities/classNames";
import { ImageSizes, ImageAnchorTypes } from "./ImageTypes";

var Image = function Image(_ref) {
  var _classNames;

  var alt = _ref.alt,
      anchor = _ref.anchor,
      fillColor = _ref.fillColor,
      fit = _ref.fit,
      height = _ref.height,
      overlay = _ref.overlay,
      sizes = _ref.sizes,
      src = _ref.src,
      srcSet = _ref.srcSet,
      width = _ref.width;
  var getClassName = getClassNameFactory(Image.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames((_classNames = {
        cover: fit === "cover"
      }, _defineProperty(_classNames, "anchor".concat(anchor), fit === "cover"), _defineProperty(_classNames, "overlay", overlay), _defineProperty(_classNames, "".concat(overlay), overlay), _classNames))
    }),
    style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, fillColor && {
      backgroundColor: fillColor
    }), fit === "cover" && {
      backgroundImage: "url(".concat(src, ")")
    }), height && {
      height: "".concat(height, "px")
    }), width && {
      width: "".concat(width, "px")
    })
  }, /*#__PURE__*/React.createElement("img", {
    className: getClassName({
      descendantName: "img"
    }),
    alt: alt,
    height: height,
    sizes: sizes,
    src: src,
    srcSet: srcSet,
    width: width
  }));
};

Image.displayName = "Image";
Image.defaultProps = {
  anchor: ImageAnchorTypes.C
}; // Provide sane defaults for sizes props on images in common scenarios.

Image.sizes = ImageSizes;
Image.AnchorTypes = ImageAnchorTypes;
export default Image;